import { API_URL, TOKEN } from "../variables/constants";

export const getCompagnieLogo = (code) => {
    return fetch(
        `${API_URL}/api/organisme/logo-code/${code}`,
        {
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                "Content-Type": "application/json",
            },
        },
    );
};